/*
    ifPlanReducer

    Creates an obj with this shape for /subscription/if endpoint

    {
        basePlan: {
            name: 'Fruit',
            id: 22,
            size: 'Medium',
        },
        addOnPlans: [3, 4, 7]
    }
*/

const ifPlanReducer = (state, action) => {
    switch (action.type) {
        case 'setBasePlanData':
            return {
                ...state,
                basePlan: {
                    ...state.basePlan,
                    name: action.name,
                    id: action.id,
                    size: action.size,
                },
            };
        case 'setBasePlanID':
            return {
                ...state,
                basePlan: {
                    ...state.basePlan,
                    id: action.planID,
                },
            };
        case 'setBasePlanSize':
            return {
                ...state,
                basePlan: {
                    ...state.basePlan,
                    size: action.size,
                },
            };
        case 'addPlan':
            return {
                ...state,
                addOnPlans: [...state.addOnPlans, action.payload],
            };
        case 'removePlan':
            return {
                ...state,
                addOnPlans: state.addOnPlans.filter((plan) => plan.id !== action.payload),
            };
        case 'modifyPlan':
            return {
                ...state,
                addOnPlans: state.addOnPlans.map((plan) => (plan.id === action.payload.id ? action.payload : plan)),
            };

        default:
            throw new Error('ifPlansReducer default hit.');
    }
};

export default ifPlanReducer;
